// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".code-copy .copy-wrap .lf[data-v-6aa42040]{background:#303030}.code-copy .copy-wrap .lf .ft-weight[data-v-6aa42040]{font-weight:600}.code-copy .copy-wrap .lf .top[data-v-6aa42040]{border-top-left-radius:4px;height:40px;background:#1c1b24;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:14px;font-weight:700}", ""]);
// Exports
module.exports = exports;
